import * as api from '../../services/item/apiAttributeValue';
import * as apiCommon from '../../services/apiCommon';
import { browserHistory } from 'react-router';
import { delay, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import * as common from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';
import * as SagasType from '../../constants/constant_saga_types';


export function* fetchListAttributeValueSaga(feathersApp) {
	yield takeLatest('FETCH_LIST_ATTRIBUTE_VALUE', callFetchListAttributeValue, feathersApp);
}

function* callFetchListAttributeValue(feathersApp, action) {
	const { silent, filters } = action;
	yield common.showProgressListTable(silent);
	try {
		const dataParams = {
			filters,
			list_type: 'attribute_value'
		};
		const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
		yield call(common.doneListTable, { rows: tableData.data, total_rows: tableData.total });
	} catch (error) {
		yield common.showErrorListTable(error);
	}
}


export function* saveAttributeValueSaga(feathersApp) {
	yield takeEvery("SAVE_ATTRIBUTE_VALUE", callSaveAttributeValue, feathersApp);
}
function* callSaveAttributeValue(feathersApp, action) {
	const { tenant, user } = yield select();
	try {
		yield put({ type: 'SAVE_RECORD_INPROGRESS' });

		const params = { tenant, user, data: action.data };
		const result = yield call(api.saveAttributeValue, feathersApp, params);
		yield common.doneSaveRecord(result, 'Attribute value was saved');
		yield put({
			type: SagasType.SIMPLE_FORM_SET_DATA,
			data: result
		});
		yield callFetchListAttributeValue(feathersApp, { silent: true });

	} catch (e) {
		yield common.showErrorSaveRecord(e);
	}
}

export function* deleteAttributeValueFromListSaga(feathersApp) {
	yield takeEvery('DELETE_ATTRIBUTE_VALUE_FROM_LIST', callDeleteAttributeValueFromList, feathersApp);
}

function* callDeleteAttributeValueFromList(feathersApp, action) {
	yield deleteAttributeValue(feathersApp, action);
	yield delay(2000);
	yield callFetchListAttributeValue(feathersApp, { silent: true });
}

function* deleteAttributeValue(feathersApp, action) {
	yield put({ type: 'DELETE_RECORD_INPROGRESS' });
	try {
		const { id } = action;
		let result = null;
		if (id) {
			const state = yield select();
			const { tenant, user } = state;
			const params = { tenant, user, id };
			result = yield call(api.deleteAttributeValue, feathersApp, params);
			yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.ATTRIBUTE_VALUE } });
			yield callFetchListAttributeValue(feathersApp, { silent: true });
		}
		return result;
	} catch (error) {
		yield put({ type: 'DELETE_RECORD_ERROR', error })
	}
}

export function* deleteAttributeValueSaga(feathersApp) {
	yield takeEvery('DELETE_ATTRIBUTE_VALUE', callDeleteAttributeValue, feathersApp);
}

function* callDeleteAttributeValue(feathersApp, action) {
	const result = yield deleteAttributeValue(feathersApp, action);
	yield delay(2000);
	if (result) {
		browserHistory.push('/admin/matrix/value');
	}
}

export function* fetchAttributeValueForEditSaga(feathersApp) {
	yield takeEvery('FETCH_ATTRIBUTE_VALUE_BY_ID', callFetchAttributeValueForEdit, feathersApp);
}

function* callFetchAttributeValueForEdit(feathersApp, action) {
	const { tenant, user } = yield select();
	const { id } = action;
	const docType = DocType.ATTRIBUTE_VALUE;
	try {
		if (id) {
			yield put({ type: "FETCH_DATA_BY_ID_INPROGRESS", payload: { docType, id } });
			const fetchParams = { tenant, user, id };
			const doc = yield call(api.fetchAttributeValueById, feathersApp, fetchParams);
			yield common.doneDataById(doc);
			yield put({
				type: SagasType.SIMPLE_FORM_SET_DATA,
				data: doc
			});
		}
	} catch (error) {
		yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
	}
}
